import { useState } from 'react'
import OtpInput from 'react-otp-input'
import { toast } from 'react-toastify'
import { ShieldLock } from 'react-bootstrap-icons'
import { AppModal, ModalActions } from '../../../../_metronic/common/modal'
import OTPImage from '../../../../_metronic/assets/images/otp_img.png'
import { toastErrorDisplay } from '../../../../_metronic/helpers/toastErrorDisplay'
import { authResendOtpAPI, authVerifyOtpAPI } from '../core/_requests'
import { useAuth } from '../core/Auth'
import { setAuth } from '../core/AuthHelpers'
import { useNavigate } from 'react-router-dom'

const OTPModal = ({ showModal, handleModal, token }) => {
  const [otp, setOtp] = useState('')
  // const [saveToken, setSaveToken] = useState(null)
  const [loadingProcess, setLoadingProcess] = useState(false)
  const { auth, setCurrentUser, saveAuth, saveAuthToken } = useAuth()
  const navigate = useNavigate()

  const handleOTPSubmit = async (e) => {
    // e.preventDefault();
    try {
      const payloadBody = {
        id: auth.id,
        token: auth.token,
        code: otp,
      }

      const res = await authVerifyOtpAPI(payloadBody)
      if (res?.data?.result) {
        saveAuth(res.data)
        saveAuthToken(res.data)
        setAuth(res.data)
        setCurrentUser(res?.data?.result)
        localStorage.setItem('device_code', res.data.device_code)
        navigate('/dashboard')
      }

      //   if (!status) {
      //     toast.error("You are not authorize for this app");
      //   }
      //   setDeviceCode(res.device_code);
      handleModal()
    } catch (error) {
      console.log('error', error)
      toast.error(error.errorTitle)
    }
  }
  const handleResendOTP = async (e) => {
    e.preventDefault()
    setLoadingProcess(true)
    try {
      const payloadBody = {
        id: auth.id,
        token: auth.token,
      }
      await authResendOtpAPI(payloadBody)

      toast.success('New OTP sent on your email')
    } catch (error) {
      toastErrorDisplay(error)
    } finally {
      setLoadingProcess(false)
    }
  }

  // useEffect(() => {
  //   if (token) {
  //     setSaveToken(token)
  //   }
  // }, [token])

  return (
    <AppModal
      show={showModal}
      onHide={handleModal}
      size='md'
      className='otp-modal-section'
      title='OTP verification'
      subtitle='Enter the code sent to your email'
      icon={<ShieldLock />}
      footer={
        <ModalActions
          onCancel={handleResendOTP}
          cancelLabel='Resend code'
          submitLabel='Verify'
          onSubmit={() => handleOTPSubmit()}
          disabled={otp?.length !== 6}
          loading={loadingProcess}
        />
      }
    >
      <div className='text-center'>
        <img src={OTPImage} alt='' style={{ maxHeight: '8rem' }} />
      </div>
      <div className='form-group'>
        <OtpInput
          // inputType="number"
          containerStyle={{
            justifyContent: 'center',
            fontSize: '3rem',
            padding: '1rem',
          }}
          value={otp}
          onChange={setOtp}
          placeholder='------'
          isInputNum={true}
          shouldAutoFocus={true}
          numInputs={6}
          renderSeparator={<span> &nbsp;</span>}
          renderInput={(props) => <input {...props} />}
        />
      </div>
    </AppModal>
  )
}

export default OTPModal
